module.exports = require("immutable");


//////////////////
// WEBPACK FOOTER
// external "immutable"
// module id = 4
// module chunks = 0 1